/*
 * @Description: qiankun main
 * @Date: 2021-09-18 15:10:30
 */
import {
  registerMicroApps,
  runAfterFirstMounted,
  setDefaultMountApp,
  start,
  addGlobalUncaughtErrorHandler,
  loadMicroApp
} from 'qiankun';

import apps from './micros/index';

let checkTimer = null; // 子容器检查器
/**
 *  注册子应用
 */
registerMicroApps(apps, {
  beforeLoad: app => {
    console.log('before load %c%s', 'color: green;', app.name);
  },
  beforeMount: [
    app => {
      console.log('before mount %c%s', 'color: green;', app.name);
    }
  ],
  afterMount: [
    app => {
      console.log('after mount %c%s', 'color: green;', app.name);
    }
  ],
  afterUnmount: [
    app => {
      console.log('after unmount %c%s', 'color: green;', app.name);
    }
  ]
});

/**
 *  设置默认进入的子应用
 */
// setDefaultMountApp('/'); 会导致主应用重载时默认跳转到/

/**
 *  启动应用
 */
start({
  prefetch: true,
  sandbox: true
}); // 注意调用时机，容器 DOM 加载完成： https://qiankun.umijs.org/zh/faq#application-died-in-status-not_mounted-target-container-with-container-not-existed-while-xxx-loading

runAfterFirstMounted(() => {
  console.log('[MainApp] first app mounted');
});
// 全局异常监听
addGlobalUncaughtErrorHandler(event => {
  console.error(event);
  if (event.type === 'error') {
    // 未找到子应用盒子，定时检查元素并手动挂载
    if (event.message.includes('LOADING_SOURCE_CODE')) {
      clearInterval(checkTimer);
      checkTimer = setInterval(() => {
        console.log('未找到#subapp-container，进行interval');
        if (document.getElementById('subapp-container')) {
          loadMicroApp(apps[0]); // FIXME: 目前只有一个子应用，故在此写死[0]
          clearInterval(checkTimer);
          console.log('#已找到subapp-container，进行手动挂载');
        }
      }, 500);
    }
  }
});
